
import React from 'react';

import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} 
                    style={{backgroundColor: "var(--primary-color)"}}
                    sx={{
                        '.MuiLinearProgress-bar': {
                            backgroundColor: "var(--secondary-color)"
                        }
                    }}/>
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary' }}
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}

function GTCLinearProgress(props: any) {
    return (
        <Box sx={{ width: '100%' }}>
            <LinearProgressWithLabel value={props.progress} />
        </Box>
    )
}

export default GTCLinearProgress;